<!--
 * @Author: sunbingqing
 * @Date: 2021-11-26 18:03:43
 * @LastEditors: sunbingqing
 * @LastEditTime: 2021-11-29 15:40:53
 * @Description: 
 * @Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
  <div>
    <van-dialog
      v-model="protocolShow"
      title="用户协议及隐私政策"
      cancel-button-text="不同意"
      confirm-button-text="同意并使用"
      message-align="left"
      confirm-button-color="#0076ff"
      cancel-button-color="#666"
      show-cancel-button
      @cancel="onCancelProtocol"
      @confirm="onConfirmProtocol"
    >
      <div class="protocol-content">
        亲爱的用户，感谢您信任并使用小麦助教。<br />我们依据相关法律法规规定了<a :href="`${host}xiaoxuntong/protocol.html`">《用户协议》</a>、<a :href="`${host}xiaoxuntong/privacy1116.html`">《隐私政策》</a>和<a :href="`${host}children_protocol.html`">《儿童隐私保护说明》</a>以便您了解我们收集、使用、存储和共享个人信息的情况，如您点击同意，则代表充分理解相关条款的内容。
      </div>
    </van-dialog>
    <van-dialog
      v-model="protocolTipsShow"
      title="温馨提示"
      confirm-button-text="同意并使用"
      message-align="left"
      confirm-button-color="#0076ff"
      @confirm="onConfirmProtocolTips"
    >
      <div class="protocol-content">
        您需要同意<a :href="`${host}xiaoxuntong/protocol.html`">《用户协议》</a>、<a :href="`${host}xiaoxuntong/privacy1116.html`">《隐私政策》</a>和<a :href="`${host}children_protocol.html`">《儿童隐私保护说明》</a
        >后我们才能继续为您提供服务。如您依旧拒绝，我们无法提供相应服务，您可通过手动关闭当前页退出。
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    [Dialog.Component.name]: Dialog.Component,
  },

  watch: {
    show(newVal) {
      this.protocolShow = newVal;
    },
  },

  data() {
    return {
      protocolShow: this.show,
      protocolTipsShow: false,
      host: window.CONFIG.parentHost[window.CONFIG.env] + 'assets/'
    };
  },

  methods: {
    onCancelProtocol() {
      this.protocolTipsShow = true;
      this.$emit('cancel');
    },
    onConfirmProtocol() {
      this.$emit('ok');
    },
    onConfirmProtocolTips() {
      this.protocolTipsShow = false;
      this.$emit('ok');
    }
  },
};
</script>

<style lang="less" scoped>
.van-dialog {
  width: 6.4rem;
  .protocol-content {
    padding: 0.48rem;
    text-align: left;
    a {
      color: #0076ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/common/ProtocolModal.vue